import { makeCygnusApiCall } from "../../../api/api";
import { COIClientSummary, COIConflictMatch } from "./ConflictCheckResults.types";

export interface FetchConflictMatchesResult {
  matches: COIConflictMatch[];
  clientSummary?: COIClientSummary;
  canDecide: boolean;
}

export const fetchConflictMatches = async (
  clientMasterId: number,
  processedTemplateId?: number
): Promise<FetchConflictMatchesResult> => {
  const params = new URLSearchParams({ ClientMasterId: String(clientMasterId) });
  if (processedTemplateId) {
    params.set("ProcessedTemplateId", String(processedTemplateId));
  }

  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/firm_setup/coi_conflict_matches?${params.toString()}`,
    show_message: false,
    customized_success_message: "Fetched conflict check results successfully.",
    customized_failure_message: "Failed to fetch conflict check results.",
    customized_error_message: "Error occurred while fetching conflict check results.",
    isblob: false,
    forMDM: true,
  });

  return {
    matches: response?.data ?? [],
    clientSummary: response?.client_summary,
    canDecide: Boolean(response?.can_decide),
  };
};

export interface SaveConflictDecisionPayload {
  COIConflictMatchId: number;
  Decision: "Proceed" | "Stop";
  Comment?: string;
}

export const saveConflictDecisions = async (
  clientMasterId: number,
  decisions: SaveConflictDecisionPayload[],
  saveAsDraft: boolean,
  processedTemplateId?: number
): Promise<boolean> => {
  const payload = {
    ClientMasterId: clientMasterId,
    ProcessedTemplateId: processedTemplateId,
    Decisions: decisions,
    SaveAsDraft: saveAsDraft,
  };

  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/firm_setup/coi_conflict_check",
    payload,
    show_message: true,
    customized_success_message: saveAsDraft
      ? "Draft saved successfully."
      : "Conflict check resolved successfully.",
    customized_failure_message: "Failed to save conflict check decisions.",
    customized_error_message: "Error occurred while saving conflict check decisions.",
    isblob: false,
    forMDM: true,
    default_message: true,
  });

  return response.success;
};
